$.softpos = {
	
	_openIntent: function(params) {
		
		params.unshift('intent:#Intent')
		params.push('S.Login=' +  encodeURIComponent('agent@mosgaz.demo'))
		params.push('S.AccessCode=331337')
		params.push('i.CardWaitingTimeout=60')
		params.push('end|')
		
		document.location.href = params.join(';');
	},
	
	intentPayment: function (options){
		
		let status = false;
		
		if(!options.purchases){
			return this._error('incorrect purchases option')
		}
		
		let amount = parseFloat(options.amount)
		
		if(!amount){
			return this._error('incorrect amount option')
		}
		
		if(!options.description){
			options.description = 'Доплата за услуги по договорам ВДГО';
		}
		
		let params = [
			'action=com.tap2go.softpos.acceptpayment',
			'd.Amount=' +  amount.toFixed(2),
			"S.Purchases=" + encodeURIComponent(JSON.stringify(options.purchases)),
			'S.Description=' + encodeURIComponent(options.description),
			'i.Currency=643',
			'S.PaymentMethod=card',
		]
		
		if(options.ext_id){
			params.push('S.ExtID=' +  encodeURIComponent(options.ext_id))
		}
		
		if(options.receipt && options.receipt.email && this._validateEmail(options.receipt.email)){
			params.push('S.ReceiptEmail=' +  encodeURIComponent(options.receipt.email))
		}else if(options.receipt && options.receipt.phone && this._validatePhone(options.receipt.phone)){
			params.push('S.ReceiptPhone=' + options.receipt.phone.replace(/\D+/g, ''))
		}
		
		this._openIntent(params)
		
		return this._success(options.ext_id)
	},
	
	intentReturn: function (options){
		
		let status = false;
		
		if(!options.purchases){
			return this._error('incorrect purchases option')
		}
		
		let amount = parseFloat(options.amount)
		
		if(!amount){
			return this._error('incorrect amount option')
		}
		
		if(!options.mode){
			return this._error('mode must be set')
		}
		
		if(!options.tranID){
			return this._error('tranID must be set')
		}
		
		let params = [
			'action=com.tap2go.softpos.reversepayment',
			'd.Amount=' +  amount.toFixed(2),
			'S.Purchases=' + encodeURIComponent(JSON.stringify(options.purchases)),
			'S.Mode=' +  encodeURIComponent(options.mode),
			'S.TranID=' +  encodeURIComponent(options.tranID)
		]
		
		this._openIntent(params)
		
		return this._success(options.tranID)
	},
	
	_error: function (error){
		console.log('intent init error: ' + error)
		return {status: false, error: error}
	},
	
	_success: function (id){
		return {status: true, id: id}
	},
	
	_validateEmail: function (email){
		const EMAIL_REGEXP = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
		return EMAIL_REGEXP.test(email)
	},

	_validatePhone: function (phone) {
		const pattern = /^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,4}[-\s.]?[0-9]{1,4}$/;
		return pattern.test(phone);
	},
	
}